import React, { ChangeEvent } from 'react'
import { ConsentText } from '@mobi/account/Areas/SignUp/Components/Message/ConsentText'
import { Checkbox } from '@mobi/component-library/Selection&Input/Inputs'
import { FeatureFlags } from '@mobi/settings/featureFlags'
import { useHostContextFeature } from '@mobi/account/Hooks'

type Props = { isBusy: boolean; onChange: (e: ChangeEvent<HTMLInputElement>) => void }
export const DocumentPermission = ({ isBusy, onChange }: Props) => {
  const isAmlRiskAssessed = useHostContextFeature(FeatureFlags.AML_SIGNUP_RISK_ASSESSMENT.key)
  return (
    <Checkbox
      name='ConsentText'
      label={<ConsentText isAmlRiskAssessed={isAmlRiskAssessed} />}
      isDisabled={isBusy}
      onChange={e => onChange(e)}
    />
  )
}
